import React from "react";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";
import InlineBanner from "../common/InlineBanner";
import { getStatusMessageColors, StatusTone } from "../../utils/labPanelStatus";

/**
 * The one-line notice History's listings show above their rows — a source
 * that failed, pages still arriving, a scope that can't load everything.
 * Wraps `InlineBanner` with the tone colours and the compact sizing the tabs
 * share, so the dozen call sites don't each repeat them.
 */
const HistoryBanner = ({ tone, text }: { tone: StatusTone; text: string }) => {
  const theme: Theme = useTheme();
  const colors = getStatusMessageColors(tone, theme);
  return (
    <InlineBanner
      text={text}
      backgroundColor={colors.backgroundColor}
      iconColor={colors.iconColor}
      marginBottom={8}
      fontSize={12}
    />
  );
};

export default HistoryBanner;
